import { WidgetSize } from 'shared/constants/widgets'

import { WidgetComponent } from '../../types/widgets.types'
import {
  CalendarLargeWidget,
  CalendarMediumWidget,
  CalendarSmallWidget
} from './components'

export const CalendarWidget: WidgetComponent = ({ ...widgetProps }) => {
  switch (widgetProps.widget.size) {
    case WidgetSize.LARGE:
      return (
        <CalendarLargeWidget
          showAddEventButton={widgetProps.isInFullView}
          {...widgetProps}
        />
      )
    case WidgetSize.MEDIUM:
      return <CalendarMediumWidget {...widgetProps} />
    default:
      return <CalendarSmallWidget {...widgetProps} />
  }
}
